import { fetchbase } from '../../utils/api.util';
import { createApi } from '@reduxjs/toolkit/query/react';

export type SmartLinksTag = 'SmartLinks' | 'SmartLink' | 'SmartLinksStats';

export const emptySmartLinksApi = createApi({
  reducerPath: 'smartLinksApi',
  baseQuery: fetchbase,
  tagTypes: ['SmartLinks', 'SmartLink', 'SmartLinksStats'] as const,
  endpoints: () => ({}),
});
